module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset> ';
 if ( context === "setup" ) { 
__p+=' <legend>'+
((__t=( i18n.tc( "UnitSearch", "Set up a new device" ) ))==null?'':__t)+
'</legend> ';
 } 
__p+=' ';
 if ( context === "search" || context === "installer" ) { 
__p+=' <legend>'+
((__t=( i18n.tc( "UnitSearch", "Search for a device" ) ))==null?'':__t)+
'</legend> ';
 } 
__p+=' ';
 if ( context === "replace" ) { 
__p+=' <legend>'+
((__t=( i18n.tc( "UnitSearch", "Enter the serial number for the new device" ) ))==null?'':__t)+
'</legend> ';
 } 
__p+=' ';
 if ( context === "accessory" ) { 
__p+=' <legend>'+
((__t=( i18n.tc( "UnitSearch", "Add new accessory" ) ))==null?'':__t)+
'</legend> ';
 } 
__p+=' </fieldset><fieldset><div><label for="search-serial-input">'+
((__t=( i18n.tc( "UnitSearch", "Serial number:" ) ))==null?'':__t)+
'</label> <input type="text" id="search-serial-input" data-input="search-serial" required><p class="hidden input error" data-text="search-bluetooth-error">'+
((__t=( i18n.tc( "UnitSearch", "This serial number belongs to a Bluetooth device. Please install and use the DEFA app on your Bluetooth enabled phone or tablet." ) ))==null?'':__t)+
'</p></div> ';
 if ( context === "installer" ) { 
__p+=' <div class="input"><small><a href="#" data-click="search-reg">'+
((__t=( i18n.tc( "UnitSearch", "Search by registration number" ) ))==null?'':__t)+
'</a></small></div> ';
 } 
__p+=' ';
 if ( help ) { 
__p+=' <div class="input"><small><a href="#" data-click="search-help">'+
((__t=( i18n.tc( "UnitSearch", "Need help finding the serial number?" ) ))==null?'':__t)+
'</a></small></div> ';
 } 
__p+=' </fieldset><fieldset class="button-wrap"> ';
 if ( hasCancelButton ) { 
__p+=' <button data-click="search-cancel">'+
((__t=( i18n.tc( "UnitSearch", "Cancel" ) ))==null?'':__t)+
'</button> ';
 } 
__p+=' <button class="primary" data-click="search-submit" disabled="disabled">'+
((__t=( i18n.tc( "UnitSearch", "Search" ) ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
